import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { PollItemData } from "../../models/PollItemData";
import { Router } from "@angular/router";
import { ApiService } from "../../shared/api.service";

@Component({
  selector: "vc-poll-dashboard-item",
  templateUrl: "poll-dashboard-item.component.html",
  styleUrls: ["./poll-dashboard-item.component.less", "../../shared/common.less"],
})
export class PollDashboardItemComponent implements OnInit {
  @Input() pollData: PollItemData;
  @Input() column: number;
  @Input() super: boolean = false;
  warningPopup = false;
  startDate: string;
  endDate: string;
  dates: string;
  @Output() openPollEvent = new EventEmitter<boolean>();
  @Output() deletePollEvent = new EventEmitter<boolean>();
  @Output() editPollEvent = new EventEmitter<boolean>();
  @Output() clonePollEvent = new EventEmitter<boolean>();
  hideEditButton = false;
  displayClock: boolean = true;

  constructor(private router: Router, private apiService: ApiService) {}

  openPoll($event) {
    if ($event.target.id.localeCompare('delete-icon') != 0 &&
        $event.target.id.localeCompare("edit-icon") != 0 &&
        $event.target.id.localeCompare("clone-icon") != 0&&
        $event.target.id.localeCompare("export-icon") != 0) {
      this.openPollEvent.emit(true);
    }
  }

  deletePoll() {
    if(this.column !== 0) {
      this.apiService.deletePoll(this.pollData.id).subscribe(
        (res) => {
          this.deletePollEvent.emit(true);
        },
        (err) => {
          console.log(err);
        }
      );
    } else {
      this.apiService.deleteDraft(this.pollData.id).subscribe(
        (res) => {
          this.deletePollEvent.emit(true);
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }

  editPopup() {
    this.editPollEvent.emit(true);
  }

  deletePopup() {
    this.warningPopup = true;
  }

  cloneAction() {
    this.clonePollEvent.emit(true);
  }

  exportAction() {
    this.apiService.getExportTokens(this.pollData.id).subscribe();
  }

  dismissDeletePopup($event) {
    this.warningPopup = false;
    if ($event) { this.deletePoll(); }
  }

  formatedDate(startDate: string, endDate: string): string {
    const start = new Date(startDate);
    const end = new Date(endDate);
    
    const startDay = start.getDate().toString().padStart(2, '0');
    const startMonth = (start.getMonth() + 1).toString().padStart(2, '0');
    const startYear = start.getFullYear();
    const startHours = start.getHours().toString().padStart(2, '0');
    const startMinutes = start.getMinutes().toString().padStart(2, '0');
    
    const endDay = end.getDate().toString().padStart(2, '0');
    const endMonth = (end.getMonth() + 1).toString().padStart(2, '0');
    const endYear = end.getFullYear();
    const endHours = end.getHours().toString().padStart(2, '0');
    const endMinutes = end.getMinutes().toString().padStart(2, '0');
    
    // Vérifier si les dates sont le même jour
    if (startDay === endDay && startMonth === endMonth && startYear === endYear) {
      this.displayClock = false;
      return `Du ${startDay}/${startMonth}/${startYear}\nde ${startHours}:${startMinutes} à ${endHours}:${endMinutes}`;
    } else {
      this.displayClock = true;
      return `Le ${startDay}/${startMonth}/${startYear} à ${startHours}:${startMinutes}\nau ${endDay}/${endMonth}/${endYear} à ${endHours}:${endMinutes}`;
    }
  }

  ngOnInit() {
    this.hideEditButton = !this.pollData.editable;
    this.dates = this.formatedDate(this.pollData.startDate, this.pollData.endDate);

    this.startDate = new Date(this.pollData.startDate).toLocaleDateString();
    this.endDate = new Date(this.pollData.endDate).toLocaleDateString();
  }
}
